'use strict'

export const SELECT_INSTRUMENTS = "SELECT_INSTRUMENTS";
export const SELECT_USERS = "SELECT_USERS";
export const SELECT_RULES = "SELECT_RULES";
export const SELECT_EMAIL = "SELECT_EMAIL";
export const SELECT_SERVICE= "SELECT_SERVICE";
export const SELECT_MESSAGE = "SELECT_MESSAGE";
export const SELECT_PREVIEW = "SELECT_PREVIEW";


export const SELECT_INSTRUMENTS_LABEL = "Select Instruments";
export const SELECT_USERS_LABEL = "Select Users";
export const SELECT_RULES_LABEL = "Select Rules";
export const SELECT_SERVICE_LABEL = "Action : Service";
export const SELECT_EMAIL_LABEL = "Action : Email";
export const SELECT_MESSAGE_LABEL = "Action : Message";
export const SELECT_PREVIEW_LABEL = "Preview";

export const SELECT_CONFIGURATION = "SELECT_CONFIGURATION";
export const SELECT_CONFIGURATION_LABEL = "Configuration";
export const START_DATE_REQUIRED_ERR_MSG = "Start date is required";
export const END_DATE_BEYOND_YEAR_ERR_MSG = "End date cannot be beyond 1 year from start date";
export const END_DATE_BEFORE_START_ERR_MSG = "End date cannot be before start date";

export const FEATURE_SERVICE_REQUEST = "serviceRequest";
export const ROLE_TRIGGER_ADMIN = "role::triggerAdmin"

export const FETCH_INSTRUMENTS_SUCCESS = "FETCH_INSTRUMENTS_SUCCESS";
export const FETCH_INSTRUMENTS_FAILURE = "FETCH_INSTRUMENTS_FAILURE";
export const FETCH_INSTRUMENTS_REQUEST = "FETCH_INSTRUMENTS_REQUEST";
export const FETCH_DROPDOWN_OPTIONS_FAILURE = "FETCH_DROPDOWN_OPTIONS_FAILURE";
export const FETCH_DROPDOWN_OPTIONS_REQUEST = "FETCH_DROPDOWN_OPTIONS_REQUEST";
export const FETCH_DROPDOWN_OPTIONS_SUCCESS = "FETCH_DROPDOWN_OPTIONS_SUCCESS";
export const SET_TRIGGER_JSON = "SET_TRIGGER_JSON";
export const FETCH_USER_GROUP_DROPDOWN_OPTIONS_REQUEST = "FETCH_USER_GROUP_DROPDOWN_OPTIONS_REQUEST";
export const FETCH_USER_GROUP_DROPDOWN_OPTIONS_SUCCESS = "FETCH_USER_GROUP_DROPDOWN_OPTIONS_SUCCESS";
export const FETCH_USER_GROUP_DROPDOWN_OPTIONS_FAILURE = "FETCH_USER_GROUP_DROPDOWN_OPTIONS_FAILURE";
export const SET_USER_FILTER_DATA = "SET_USER_FILTER_DATA";
export const SET_MESSAGE_JSON ="SET_MESSAGE_JSON";
export const SEARCH_SELECTED_USERS = "SEARCH_SELECTED_USERS";
export const FETCH_RULE_CRITERIA_SUCCESS = "FETCH_RULE_CRITERIA_SUCCESS";
export const FETCH_RULE_CRITERIA_FAILURE= "FETCH_RULE_CRITERIA_FAILURE";
export const FETCH_RULE_CRITERIA_REQUEST = "FETCH_RULE_CRITERIA_REQUEST";
export const INSTANCE_ID = "instanceId";
export const MODEL = "model";
export const RULE = "rule";
export const USER = "user";
export const STATUS = "status";

export const COUNTRY = "country";
export const WORK_ORDER = "WO";
export const SERVICE_NOTE = "SN";
export const TIME = "TIME";
export const ACTION_CHECKBOX = "ACTION";
export const WORK_ORDER_CHECKBOX = "WORK_ORDER";
export const SERVICE_NOTE_CHECKBOX = "SERVICE_NOTE";
export const TIME_UNIT_TYPE = "TIME_UNIT";
export const ACTION_NAME = "ACTION_NAME";
export const ACTION_DESC = "ACTION_DESC";
export const SUBJECT = "SUBJECT";
export const EMAIL_BODY = "EMAIL_BODY";
export const RECIPIENT = "RECIPIENT";
export const SMS_BODY = "SMS_BODY";
export const NUMBERS = "NUMBERS";
export const USERS ="USERS";
export const SELECTED_USERS ="SELECTED_USERS";


export const SET_FILTER_DATA ="SET_FILTER_DATA";
export const ONLY_DIGIT_ALLOWED = "only digits are allowed";
export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";
export const SEARCH_USERS = "SEARCH_USERS";
export const OPEN_ERROR_MESSAGE_POPUP = "OPEN_ERROR_MESSAGE_POPUP";
export const CLOSE_ERROR_MESSAGE_POPUP= "CLOSE_ERROR_MESSAGE_POPUP";
export const CLOSE_SELECT_INSTRUMENT_ERROR_MESSAGE_DIALOG = "CLOSE_SELECT_INSTRUMENT_ERROR_MESSAGE_DIALOG";
export const FETCH_RULES_REQUEST = "FETCH_RULES_REQUEST";
export const FETCH_RULES_SUCCESS = "FETCH_RULES_SUCCESS";
export const FETCH_RULES_FAILURE = "FETCH_RULES_FAILURE";
export const SET_RULE_FILTER_DATA= "SET_RULE_FILTER_DATA";
export const SEARCH_SELECTED_INSTANCE="SEARCH_SELECTED_INSTANCE";
export const TYPE ="TYPE";
export const CLOSE_CONFIRM_POPUP = "CLOSE_CONFIRM_POPUP";
export const OPEN_CONFIRM_POPUP = "OPEN_CONFIRM_POPUP";
export const REQUEST_CREATE_TRIGGER ="REQUEST_CREATE_TRIGGER";
export const SAVE_POPUP_TITLE = "TRIGGERS";
export const CREATE_TRIGGER_REQUEST = "CREATE_TRIGGER_REQUEST";
export const CREATE_TRIGGER_SUCCESS = "CREATE_TRIGGER_SUCCESS";
export const CREATE_TRIGGER_FAILURE = "CREATE_TRIGGER_FAILURE";
export const RESET_TRIGGER_DATA= "RESET_TRIGGER_DATA";
export const EDIT_RESET_TRIGGER_DATA = "EDIT_RESET_TRIGGER_DATA";
export const CLOSE_ERROR_TRIGGER_POPUP= "CLOSE_ERROR_TRIGGER_POPUP";
export const CLOSE_OFFLINE_SUCCESS_POPUP = "CLOSE_OFFLINE_SUCCESS_POPUP";
export const OFFLINE_TRIGGER_SAVED_MESSAGE = "Offline trigger configuration saved successfully.";
export const OFFLINE_TRIGGER_SAVE_ERROR_MESSAGE = "Failed to save offline configuration trigger. Please try again.";
export const SET_ACTIVE_LINK = "SET_ACTIVE_LINK";
export const FETCH_SELECTED_INSTRUMENT_SUCCESS = "FETCH_SELECTED_INSTRUMENT_SUCCESS";
export const SET_RULE_VIEW_FILTER = "SET_RULE_VIEW_FILTER";
export const FETCH_FILTERED_RULES_REQUEST ="FETCH_FILTERED_RULES_REQUEST";
export const FETCH_FILTERED_RULES_SUCCESS = "FETCH_FILTERED_RULES_SUCCESS";
export const FETCH_FILTERED_RULES_FAILURE = "FETCH_FILTERED_RULES_FAILURE";
export const RESET_RULE_VIEW_FILTER_DATA ="RESET_RULE_VIEW_FILTER_DATA";
export const OPEN_ERROR_RULE_MESSAGE_POPUP="OPEN_ERROR_RULE_MESSAGE_POPUP";
export const CLOSE_ERROR_RULE_MESSAGE_POPUP ="CLOSE_ERROR_RULE_MESSAGE_POPUP";
export const OPEN_TRIGGER_STATUS_POPUP = "OPEN_TRIGGER_STATUS_POPUP";
export const CLOSE_TRIGGER_STATUS_POPUP = "CLOSE_TRIGGER_STATUS_POPUP";
export const SET_TRIGGER_STATUS_REQUEST = "SET_TRIGGER_STATUS_REQUEST";
export const SET_TRIGGER_STATUS_SUCCESS = "SET_TRIGGER_STATUS_SUCCESS";
export const SET_TRIGGER_STATUS_FAILURE = "SET_TRIGGER_STATUS_FAILURE";
export const CLOSE_TRIGGER_SUCCESS_STATUS_POPUP="CLOSE_TRIGGER_SUCCESS_STATUS_POPUP";
export const CLOSE_TRIGGER_ERROR_STATUS_POPUP ="CLOSE_TRIGGER_ERROR_STATUS_POPUP";
export const SET_TRIGGER_PANEL_TYPE = "SET_TRIGGER_PANEL_TYPE";
export const SET_EDIT_TRIGGER_PANEL_TYPE ="SET_EDIT_TRIGGER_PANEL_TYPE";
export const GET_TRIGGER_INFO = "GET_TRIGGER_INFO";
export const OPEN_EDIT_TRIGGER_ERROR_DIALOG = "OPEN_EDIT_TRIGGER_ERROR_DIALOG";
export const CLOSE_EDIT_TRIGGER_ERROR_DIALOG = "CLOSE_EDIT_TRIGGER_ERROR_DIALOG";

export const TIME_UNITS=[{"label":"Days","value":"days"},{"label":"Hours","value":"hours"},{"label":"Minutes","value":"minutes"}];
export const SELECTED_TIME_UNIT = TIME_UNITS[0]
export const INST_MODEL_SELECT_ERROR = "User cannot choose instruments that belong to more than one model."
export const RULE_MODEL_SELECT_ERROR = "Rule selected is different to the model of instruments choosen during instrument selection."
export const SINGLE_RULE_SELECT_ERROR="User cannot select more than one rule."
export const CONFIRMATION_TRIGGER_MESSAGE = "Are you sure you want to confirm changes ?";


export const SAVED_TRIGGER_MESSAGE = "Trigger saved successfully.";
export const UPDATED_TRIGGER_MESSAGE = "Trigger updated successfully.";
export const FAILURE_TRIGGER_MESSAGE = "Changes are not saved due to a technical error, please try again later";
export const EDIT_TRIGGER_ERROR_MESSAGE = "Your role do not have permission to edit this trigger.";
export const OPEN_EXPRESSION_POPUP ="OPEN_EXPRESSION_POPUP";
export const CLOSE_EXPRESSION_POPUP ="CLOSE_EXPRESSION_POPUP";
export const WORKORDER_EMPTY_ERR_MSG = "Enter Service case"
export const WORKORDER_SELECT_ERR_MSG = "Select Service case"
export const SERVICE_NOTE_EMPTY_ERR_MSG = "Enter Service Note"
export const TIME_EMPTY_ERR_MSG = "Required"
export const INVALID_ERR_MSG = "Invalid Data Input"
export const ACTION_NAME_EMPTY_ERR_MSG = "Enter Action Name"
export const ACTION_DESC_EMPTY_ERR_MSG = "Enter Action Description"
export const RECEPIENT_ERR_MSG = "Enter Recipient Email(s)"
export const SUBJECT_ERR_MSG = "Enter Subject"
export const BODY_ERR_MSG = "Enter Email Body"
export const SUSPENDED_TIME_TOOLTIP = "Time specifies the delay between the Previous notification to Next notification to be raised to users"
export const DEFAULT = "default"
export const VIEW_TRIGGER_PANEL_NAME = "View Triggers";
export const CREATE_TRIGGER_PANEL_NAME = "Create/Update Triggers";
export const OFFLINE_TRIGGER_PANEL_NAME = "Offline Triggers";

export const TRIGGER_STATUS_SUCCESS_MESSAGE = "Trigger status saved successfully.";

export const TRIGGER_ORDER = ["RAP", "INST", "INST_NO_DATA"];
export const TRIGGER_TYPE_LABELS = {
  RAP: "RAP/IOTGateway Box Offline Admin",
  INST: "Instrument Offline Trigger",
  INST_NO_DATA: "No Data Offline Trigger"
};
export const DURATION_VALIDATION_MSG_SUFFIX = "should be minimum of 1 hour or 1 day and maximum 744 hours, or maximum of 31 days";
export const SR_SUSPEND_TIME_VALIDATION_MSG = "SR suspend time should be a positive integer with a minimum value of 1";
export const EMAIL_SUSPEND_TIME_VALIDATION_MSG = "Email suspend time should be a positive integer with a minimum value of 1";

export const FETCH_OFFLINE_TRIGGER_CONFIGS_REQUEST = "FETCH_OFFLINE_TRIGGER_CONFIGS_REQUEST";
export const FETCH_OFFLINE_TRIGGER_CONFIGS_SUCCESS = "FETCH_OFFLINE_TRIGGER_CONFIGS_SUCCESS";
export const FETCH_OFFLINE_TRIGGER_CONFIGS_FAILURE = "FETCH_OFFLINE_TRIGGER_CONFIGS_FAILURE";
export const UPDATE_OFFLINE_TRIGGER_CONFIG_REQUEST = "UPDATE_OFFLINE_TRIGGER_CONFIG_REQUEST";
export const UPDATE_OFFLINE_TRIGGER_CONFIG_SUCCESS = "UPDATE_OFFLINE_TRIGGER_CONFIG_SUCCESS";
export const UPDATE_OFFLINE_TRIGGER_CONFIG_FAILURE = "UPDATE_OFFLINE_TRIGGER_CONFIG_FAILURE";
export const UPDATE_OFFLINE_TRIGGER_CONFIG_LOCAL = "UPDATE_OFFLINE_TRIGGER_CONFIG_LOCAL";

export const statusOptions = [
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
    { value: 'Test Mode', label: 'Test Mode' }
  ];

export const DELETE_TRIGGERS_REQUEST = "DELETE_TRIGGERS_REQUEST";
export const DELETE_TRIGGERS_SUCCESS = "DELETE_TRIGGERS_SUCCESS";
export const DELETE_TRIGGERS_FAILURE = "DELETE_TRIGGERS_FAILURE";
export const CLOSE_DELETE_TRIGGER_SUCCESS_POPUP = "CLOSE_DELETE_TRIGGER_SUCCESS_POPUP";
export const CLOSE_DELETE_TRIGGER_ERROR_POPUP = "CLOSE_DELETE_TRIGGER_ERROR_POPUP";
export const DELETE_TRIGGER_SUCCESS_MESSAGE = "Trigger(s) deleted successfully.";
export const DELETE_TRIGGER_ERROR_MESSAGE = "Failed to delete trigger(s). Please try again later.";
export const DELETE_TRIGGER_CONFIRM_MESSAGE = "Are you sure, you want to delete the Trigger ?";

export const SUCCESS_MODAL_CONFIG = [
    { flag: 'isTriggerSuccessStatusMsgPopup', msgKey: 'triggerStatusMsg' },
    { flag: 'isDeleteTriggerSuccessPopup',   msgKey: 'deleteTriggerMsg' },
];

export const ERROR_MODAL_CONFIG = [
    { flag: 'isTriggerErrorStatusMsgPopup',  msgKey: 'triggerStatusMsg' },
    { flag: 'showEditTriggerErrorDialog',    msgKey: 'editTriggerErrorMsg' },
    { flag: 'isDeleteTriggerErrorPopup',     msgKey: 'deleteTriggerMsg' },
];